function DailyRevenueReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">DailyRevenueReport</div>
      </>
    );
  }
  
  export default DailyRevenueReport;